import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export type WishlistRequest = {
    searchTerm?: string;
    item: WishlistItem;
};

export type WishlistItem = SerialNumberWishlistItem | SparePartWishlistItem;

export interface SerialNumberWishlistItem {
    type: 'SERIALNUMBER';
    productId: string;
    quantity: number;
}

export interface SparePartWishlistItem {
    type: 'SPARE_PART';
    productId: string;
    quantity: number;
    isPartOfIndustrialGear?: boolean;
}

@Injectable({ providedIn: 'root' })
export class WishlistService {
    private readonly http = inject(HttpClient);

    public addItem(request: WishlistRequest): Observable<void> {
        return this.http.post<void>('/api/wishlist', request);
    }

    public showHeaderNotification(addedItemCount: number): void {
        const headerWindow = window as Window & {
            displayHeaderNotification?: (target: 'wish-list', addedItemCount: number) => void;
        };

        headerWindow.displayHeaderNotification?.('wish-list', addedItemCount);
    }

    public showHeaderErrorNotification(): void {
        const headerWindow = window as Window & {
            displayHeaderNotification?: (target: 'wish-list-error') => void;
        };

        headerWindow.displayHeaderNotification?.('wish-list-error');
    }
}
